import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedComponent } from '@app/app-components';
import { SelectiveStrategyService } from '@app/global services';
import {
  AuthGuard,
  ViggoCorePageNotfoundComponent
} from 'viggo-sistemas-core-web';
import { routesAdmin } from './admin/routes_admin';
import { routesUnloggedUser } from './routes_unlogged';
import { routesWorkspace } from './routes_workspace';
import { routesSysadmin } from './sysadmin/routes_sysadmin';

export const routes: Routes = [
  ...routesUnloggedUser,
  {
    path: '',
    component: LoggedComponent,
    canActivate: [AuthGuard],
    children: [
      ...routesWorkspace,
      ...routesAdmin,
      ...routesSysadmin,
      // caso ele esteja na rota raiz, redireciona para o workspace
      { path: '', redirectTo: '/workspace', pathMatch: 'full' }
    ]
  },
  {
    path: '**',
    data: {
      appName: 'Viggo-Gestor',
      logoTopBar: 'assets/images/icone.png'
    },
    component: ViggoCorePageNotfoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: SelectiveStrategyService,
    })
  ],
  exports: [RouterModule],
  providers: [SelectiveStrategyService]
})
export class AppRoutingModule {}
